/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ContentfulWebhookEntryDto {
  contentfulId?: string;
}

export interface ContentfulWebhookEntryContentTypeDto {
  contentfulId?: string;
  contentType?: string;
}

export interface BillToPartyRequestDto {
  name?: string;
  postalAddress?: PostalAddress;
}

export interface PostalAddress {
  line1?: string;
  line2?: string;
  city?: string;
  country?: string;
  state?: string;
  phone?: string;
  postcode?: string;
}

export interface BillToPartyDto {
  name?: string;
  taxId?: string;
  taxIds?: TaxId[];
  postalAddress?: PostalAddress;
  priceEligibility?: PriceEligibility;
}

export interface Metadata {
  additionalProp?: string[];
}

export interface PriceEligibility {
  additionalProp?: boolean[];
}

export interface TaxId {
  id?: string;
  label?: string;
  taxIdLabel?: string;
  taxIdDescription?: string;
  metadata?: Metadata;
}

export interface Pagination {
  /** @format int32 */
  from?: number;
  /** @format int32 */
  size?: number;
}

export interface SearchDto {
  pagination?: Pagination;
  /** @uniqueItems true */
  duration?: (
    | "Less than 30 min"
    | "30 min to 1 hour"
    | "1 to 2 hours"
    | "More than 2 hours"
  )[];
  /** @uniqueItems true */
  type?: (
    | "LEARNING_PATH"
    | "COURSE"
    | "LESSON"
    | "CERTIFICATION"
    | "TEAM_TRAINING"
    | "TOPIC"
    | "ROLE"
    | "CERTIFICATION_PREP"
    | "SECTION"
  )[];
  /** @uniqueItems true */
  learningLevel?: ("BEGINNER" | "INTERMEDIATE" | "ADVANCED")[];
  /** @uniqueItems true */
  product?: (
    | "JIRA"
    | "JIRA_SERVICE_MANAGEMENT"
    | "JIRA_PRODUCT_DISCOVERY"
    | "CONFLUENCE"
    | "TRELLO"
    | "GUARD"
    | "FORGE"
    | "JIRA_ALIGN"
    | "BITBUCKET"
    | "LOOM"
    | "ROVO"
    | "COMPASS"
  )[];
  /** @uniqueItems true */
  productRole?: (
    | "ATLASSIAN_CLOUD_ORGANIZATION_ADMIN"
    | "JIRA_ADMIN"
    | "JIRA_PROJECT_ADMIN"
    | "JIRA_BOARD_ADMIN"
    | "JIRA_SERVICE_MANAGEMENT_PROJECT_ADMIN"
    | "CONFLUENCE_SPACE_ADMIN"
    | "CONFLUENCE_SITE_ADMIN"
    | "TRELLO_WORKSPACE_ADMIN"
    | "TRELLO_BOARD_ADMIN"
  )[];
  /** @uniqueItems true */
  deployment?: ("CLOUD" | "DATA_CENTER")[];
  searchValue?: string;
}

export interface AtlenzSearchResponseDto {
  /** @uniqueItems true */
  results?: Result[];
  pagination?: Pagination;
}

export interface Content {
  contentAri?: string;
  description?: string;
  title?: string;
  url?: string;
  contentType?: string;
  slug?: string;
  subType?: string;
  level?: string;
  /** @format int32 */
  duration?: number;
  durationCategory?: string;
  /** @uniqueItems true */
  productKeys?: string[];
  /** @uniqueItems true */
  productPlatforms?: string[];
  publishTo?: string[];
  metadata?: Metadata;
  products?: Product[];
  /** @uniqueItems true */
  userRoles?: string[];
}

export interface Product {
  platform?: string;
  key?: string;
}

export interface Result {
  content?: Content;
}

export interface FiltersCounters {
  /** @format int32 */
  total?: number;
  durationCounters?: Record<string, number>;
  typeCounters?: Record<string, number>;
  levelCounters?: Record<string, number>;
  productCounters?: Record<string, number>;
  deploymentCounters?: Record<string, number>;
  userRolesCounters?: Record<string, number>;
}

export interface KmsUserDto {
  id?: string;
  picture?: string;
  name?: string;
  email?: string;
}

export interface KmsUserCreationDto {
  atlassianId?: string;
}

export interface ContentfulGraphQlRequestDto {
  operationName?: string;
  query?: string;
  variables?: Record<string, any>;
}

export interface TransactionAccountRequestDto {
  description?: string;
  billingAdmin?: string;
  name?: string;
  type?: string;
}

export interface PartnerStatus {
  discountTier?: string;
  programLevelGlobal?: string;
  externalSystemIdentifier?: string;
  programLevel?: string;
}

export interface TransactionAccount {
  id?: string;
  partitionKey?: string;
}

export interface TransactionAccountResponseDto {
  id?: string;
  /** @format int32 */
  version?: number;
  transactionAccountPartition?: TransactionAccount;
  transactionAccount?: TransactionAccount;
  number?: string;
  partnerStatus?: PartnerStatus;
  /** @format int64 */
  createdAt?: number;
  /** @format int64 */
  updatedAt?: number;
  metaData?: Record<string, any>;
  name?: string;
  description?: string;
  roleAssignmentWriteToken?: string;
}

export interface ShipToPartiesRequestDto {
  name?: string;
  postalAddress?: PostalAddress;
}

export interface ShipToPartyDto {
  id?: string;
  /** @format int32 */
  version?: number;
  name?: string;
  postalAddress?: PostalAddress;
  priceEligibility?: PriceEligibility;
  taxId?: string;
  taxIds?: TaxId[];
  active?: boolean;
  /** @format int64 */
  createdAt?: number;
  /** @format int64 */
  updatedAt?: number;
  transactionAccountPartition?: TransactionAccount;
  transactionAccount?: TransactionAccount;
}

export interface AdditionalTriggeredOrderDto {
  orderId?: string;
  status?: string;
}

export interface ItemDto {
  itemId?: string;
  offeringId?: string;
  type?: string;
  relatesFromEntitlements?: ItemRelationshipDto[];
}

export interface ItemRelationshipDto {
  entitlementId?: string;
  itemId?: string;
  referenceType?: string;
  relationshipType?: string;
}

export interface MetadataDto {
  provisionRequestId?: string;
}

export interface OfferingDto {
  offeringId?: string;
  pricingType?: string;
  chargeElement?: string;
}

export interface OrderRequestDto {
  orderId?: string;
  invoiceGroupId?: string;
  transactionAccountId?: string;
  items?: ItemDto[];
  offerings?: OfferingDto[];
  additionalTriggeredOrders?: AdditionalTriggeredOrderDto[];
  metadata?: MetadataDto;
  featureOverrides?: Record<string, any>;
  changeReason?: string;
  childrenIds?: string[];
  provisionRequestId?: string;
}

export interface ItemResponseDto {
  itemId?: string;
  orderItemId?: string;
  transactionAccountId?: string;
  invoiceGroupId?: string;
  triggeredByOrderItem?: string;
  processingInfo?: string;
  metadata?: string;
}

export interface OrderResponseDto {
  orderId?: string;
  slug?: string;
  items?: ItemResponseDto[];
  transactionAccountId?: string;
  invoiceGroupId?: string;
  additionalTriggeredOrders?: any[];
  metadata?: Record<string, string>;
}

export interface InvoiceGroupRequestDto {
  name?: string;
  currency?: "USD";
}

export interface InvoiceGroupDto {
  id?: string;
  /** @format int32 */
  version?: number;
  name?: string;
  slug?: string;
  currency?: string;
  billToParty?: BillToPartyDto;
  defaultPaymentMethod?: string;
  purchaseOrder?: PurchaseOrder;
  active?: boolean;
  memo?: string;
  /** @format int64 */
  createdAt?: number;
  /** @format int64 */
  updatedAt?: number;
  recipients?: string[];
  transactionAccountPartition?: TransactionAccount;
  transactionAccount?: TransactionAccount;
  shipToParty?: ShipToPartyDto;
}

export interface PurchaseOrder {
  number?: string;
  oneTimeUse?: boolean;
}

export interface AccountEvents {
  /** @format int32 */
  accountId?: number;
  events?: Event[];
}

export interface Event {
  eventId?: string;
  eventName?: string;
  timestamp?: string;
  eventInfo?: string;
  data?: EventData;
}

export interface EventData {
  /** @format int64 */
  userId?: number;
  loId?: string;
  loInstanceId?: string;
  loType?: string;
  enrollmentSource?: string;
  dateEnrolled?: string;
}

export interface AdobeUserResponseDto {
  data?: UserDataBlock[];
}

export interface UserAttributes {
  avatarUrl?: string;
  binUserId?: string;
  bio?: string;
  contentLocale?: string;
  email?: string;
  enrollOnClick?: boolean;
  fields?: Record<string, string>;
  gamificationEnabled?: boolean;
  lastLoginDate?: string;
  metadata?: Record<string, any>;
  name?: string;
  /** @format int32 */
  pointsEarned?: number;
  /** @format int32 */
  pointsRedeemed?: number;
  preferredResolution?: string;
  profile?: string;
  roles?: string[];
  state?: string;
  timeZoneCode?: string;
  uiLocale?: string;
  userType?: string;
  userUniqueId?: string;
}

export interface UserDataBlock {
  id?: string;
  type?: string;
  attributes?: UserAttributes;
  relationships?: UserRelationships;
}

export interface UserRelationData {
  type?: string;
  id?: string;
}

export interface UserRelationDataWrapper {
  data?: UserRelationData;
}

export interface UserRelationships {
  account?: UserRelationDataWrapper;
  manager?: UserRelationDataWrapper;
}

export interface TransactionAccountsResponseDto {
  data?: TransactionAccountResponseDto[];
}

export interface ShipToPartyWrapperDto {
  data?: ShipToPartyDto[];
  lastEvaluatedKey?: string;
}

export interface AccountModification {
  invoiceGroupId?: string;
  transactionAccountId?: string;
}

export interface AdditionalTriggeredOrderItem {
  orderId?: string;
  orderItemId?: string;
  requestType?: string;
}

export interface BillUntil {
  type?: string;
  duration?: Duration;
  /** @format int64 */
  timestamp?: number;
  reference?: string;
}

export interface BillingBehaviour {
  type?: string;
  /** @format int64 */
  startTimestamp?: number;
}

export interface BillingOptions {
  preBill?: PreBill;
}

export interface ChargeQuantity {
  chargeElement?: string;
  /** @format int32 */
  quantity?: number;
}

export interface ChargingDetails {
  pricingPlanId?: string;
  chargeQuantities?: ChargeQuantity[];
}

export interface ComputedDetailsDto {
  offeringId?: string;
  /** @format int64 */
  computedEndTimestamp?: number;
  /** @format int64 */
  computedBillUntilTimestamp?: number;
  usageOptions?: OptedUsageOptions;
  removedPromotions?: RemovedPromotion[];
  orderedPromotions?: OrderedPromotion[];
  replacedPromotions?: ReplacedPromotion[];
  pricingPlanTransition?: SchedulePricingPlanTransition;
  schedulePricingPlanTransition?: SchedulePricingPlanTransition;
  scheduledChanges?: ScheduledChanges;
  computedFeatures?: ComputedFeature[];
}

export interface ComputedFeature {
  type?: string;
  chargeElement?: string;
  /** @format int32 */
  amount?: number;
  unit?: string;
}

export interface CurrencyChangeRecords {
  currency?: string;
  /** @format int32 */
  glpForNextPlan?: number;
}

export interface Duration {
  interval?: string;
  /** @format int32 */
  intervalCount?: number;
}

export interface EffectiveTime {
  startsAt?: TimeReference;
  endsAt?: TimeReference;
}

export interface Entitlement {
  id?: string;
  version?: string;
}

export interface EntitlementTransition {
  from?: Transition;
  to?: Transition;
}

export interface GlpForAllPhase {
  /** @format int32 */
  glp?: number;
  offeringId?: string;
}

export interface ImpactedEntitlement {
  version?: string;
  order?: Order;
  entitlementId?: string;
}

export interface OptedUsageOptions {
  trial?: Trial;
  chargingDetails?: ChargingDetails;
  purchaseMetadata?: Record<string, string>;
  effectiveTime?: EffectiveTime;
  billingBehaviour?: BillingBehaviour;
}

export interface Order {
  offeringId?: string;
  orderType?: string;
}

export interface OrderDetailsDto {
  orderId?: string;
  slug?: string;
  transactionAccountId?: string;
  transactionAccount?: TransactionAccount;
  invoiceGroupId?: string;
  items?: OrderItemDto[];
  additionalTriggeredOrders?: string[];
  metadata?: Record<string, string>;
  /** @format int64 */
  createdDate?: number;
}

export interface OrderItemDto {
  orderItemId?: string;
  itemId?: string;
  transactionAccountId?: string;
  invoiceGroupId?: string;
  offeringId?: string;
  type?: string;
  parentEntitlementId?: string;
  optedUsageOptions?: OptedUsageOptions;
  billingOptions?: BillingOptions;
  resetOptions?: ResetOptions;
  processingInfo?: ProcessingInfoDto;
  intendedBillingPeriodState?: string;
  isAdminOrder?: boolean;
  triggeredByOrderItem?: TriggeredByOrderItem;
  reasonCode?: string;
  featureOverrides?: Record<string, any>;
  /** @format int64 */
  trialEndTimestamp?: number;
  metadata?: Record<string, string>;
  isImmediate?: boolean;
  promotions?: Promotion[];
  quoteLineItemDetailsReference?: QuoteLineItemDetailsReference;
  originalOrderItemId?: string;
  transitionState?: TransitionState;
  /** @format int64 */
  updatedDate?: number;
  prorationBehaviour?: string;
  relatesFromEntitlements?: RelatesFromEntitlement[];
}

export interface OrderedPromotion {
  promotionInstanceId?: string;
  promotionDefinition?: PromotionDefinition;
}

export interface PreBill {
  billUntil?: BillUntil;
}

export interface ProcessingInfoDto {
  entitlement?: Entitlement;
  status?: string;
  transitionTime?: string;
  /** @format int64 */
  transitionTimestamp?: number;
  saleTransitionType?: string;
  saleTransitionDetails?: SaleTransitionDetails;
  accountModification?: AccountModification;
  computedDetails?: ComputedDetailsDto;
  impactedEntitlements?: ImpactedEntitlement[];
  additionalTriggeredOrderItems?: AdditionalTriggeredOrderItem[];
  prorationBehaviour?: string;
  prorationBehaviourInfo?: ProrationBehaviourInfo;
}

export interface Promotion {
  promotionInstanceId?: string;
  promotionDefinition?: PromotionDefinition;
}

export interface PromotionDefinition {
  promotionId?: string;
  promotionCode?: string;
  customisedValues?: Record<string, any>;
}

export interface ProrationBehaviourInfo {
  computedReasonCode?: string;
}

export interface QuoteLineItemDetailsReference {
  quoteId?: string;
  /** @format int32 */
  version?: number;
  quoteLineItemId?: string;
  quoteLineItemType?: string;
}

export interface RelatesFromEntitlement {
  relationshipType?: string;
  referenceType?: string;
  orderItemId?: string;
}

export interface RemovedPromotion {
  promotionInstanceId?: string;
  promotionDefinition?: PromotionDefinition;
}

export interface ReplacedPromotion {
  promotionInstanceId?: string;
  promotionDefinition?: PromotionDefinition;
}

export interface ResetOptions {
  resetType?: string;
  /** @format int64 */
  backdateTimestamp?: number;
  resetGlporderItemId?: string;
  invoiceRequestId?: string;
}

export interface SaleTransitionDetails {
  /** @format int32 */
  glpForLastPaidPlan?: number;
  /** @format int32 */
  glpForCurrentPlan?: number;
  /** @format int32 */
  glpForNextPlan?: number;
  /** @format int32 */
  glpForNextPlanLegacyPricing?: number;
  /** @format int32 */
  glpForScheduleNextPlanLegacyPricing?: number;
  /** @format int32 */
  currentOfferingLevel?: number;
  /** @format int32 */
  nextOfferingLevel?: number;
  saleTransitionType?: string;
  /** @format int32 */
  lastPaidOfferingLevel?: number;
  saleTransitionTime?: string;
  glpForAllPhases?: GlpForAllPhase[];
  currency?: string;
  glpGroupId?: string;
  currencyChangeRecords?: CurrencyChangeRecords;
}

export interface SchedulePricingPlanTransition {
  from?: string;
  to?: string;
}

export interface ScheduledChanges {
  chargingDetails?: ChargingDetails;
}

export interface TimeReference {
  type?: string;
  /** @format int64 */
  timestamp?: number;
  /** @format int32 */
  billingFrequencyCount?: number;
}

export interface Transition {
  id?: string;
  version?: string;
}

export interface TransitionState {
  entitlement?: EntitlementTransition;
}

export interface Trial {
  skipTrial?: boolean;
  behaviourAtEndOfTrial?: string;
  /** @format int64 */
  endTimestamp?: number;
  offeringId?: string;
  pricingPlanId?: string;
  /** @format int64 */
  startTimestamp?: number;
}

export interface TriggeredByOrderItem {
  orderId?: string;
  orderItemId?: string;
  requestType?: string;
}

export interface InvoiceGroupWrapperDto {
  data?: InvoiceGroupDto[];
  lastEvaluatedKey?: string;
}

export interface EntitlementDto {
  entitlementId?: string;
  invoiceGroupId?: string;
  /** @format int32 */
  version?: number;
  status?: string;
  slug?: string;
  offeringKey?: string;
  entitlementTemplate?: EntitlementTemplateDto;
  transactionAccountId?: string;
  order?: EntitlementOrderInfoDto;
  relatesToEntitlements?: RelationshipDto[];
  relatesFromEntitlements?: RelationshipDto[];
  /** @format int64 */
  createdAt?: number;
  /** @format int64 */
  updatedAt?: number;
}

export interface EntitlementOrderInfoDto {
  id?: string;
  itemId?: string;
}

export interface EntitlementResponseDto {
  data?: EntitlementDto[];
}

export interface EntitlementTemplateDto {
  key?: string;
  /** @format int32 */
  version?: number;
}

export interface RelationshipDto {
  relationshipType?: string;
  entitlementId?: string;
  relationshipId?: string;
}

export interface ContextDto {
  subject?: string;
  subjectType?: string;
  authMechanism?: string;
  clientAsapIssuer?: string;
}

export interface EntitlementDetailsDtoResponseDto {
  entitlementId?: string;
  /** @format int32 */
  version?: number;
  status?: string;
  slug?: string;
  offeringKey?: string;
  transactionAccountId?: string;
  order?: EntitlementOrderInfoDto;
  relatesToEntitlements?: RelationshipDto[];
  relatesFromEntitlements?: RelationshipDto[];
  /** @format int64 */
  createdAt?: number;
  /** @format int64 */
  updatedAt?: number;
  invoiceGroupId?: string;
  metadata?: MetadataDto;
  featureOverrides?: Record<string, any>;
  changeReason?: string;
  childrenIds?: string[];
  enableAbuseProneFeatures?: boolean;
  context?: ContextDto;
}

export interface FilterInfo {
  appliedFilters?: string[];
  availableFilters?: string[];
  /** @format int32 */
  totalBeforeFilter?: number;
  /** @format int32 */
  totalAfterFilter?: number;
}

export interface IltCard {
  courseId?: string;
  courseName?: string;
  courseDescription?: string;
  sessionInfo?: IltSessionInfo;
  enrollmentStatus?: "ENROLLED" | "COMPLETED" | "STARTED" | "NOT_ENROLLED";
  isBookmarked?: boolean;
  isFree?: boolean;
  isPrivate?: boolean;
  tags?: string[];
  filterTags?: string[];
}

export interface IltLearningCardsResponse {
  courses?: IltCard[];
  pagination?: PaginationInfo;
  filters?: FilterInfo;
}

export interface IltSessionInfo {
  sessionId?: string;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  /** @format int32 */
  durationMinutes?: number;
  type?: "VIRTUAL_CLASSROOM" | "CLASSROOM";
  meetingLink?: string;
  location?: string;
  instructors?: string[];
}

export interface PaginationInfo {
  nextCursor?: string;
  hasMore?: boolean;
  /** @format int32 */
  totalResults?: number;
  /** @format int32 */
  pageSize?: number;
}

export interface AdobeCourseResponseDto {
  cursor?: Cursor;
  data?: CourseDataBlock[];
  included?: CourseDataBlock[];
}

export interface AuthorDetail {
  authorId?: string;
  authorName?: string;
  authorType?: string;
}

export interface CatalogLabel {
  catalogLabelValueIds?: CatalogLabelValueId[];
  description?: string;
  id?: string;
  mandatory?: boolean;
  name?: string;
  type?: string;
  values?: string[];
}

export interface CatalogLabelValueId {
  id?: string;
  name?: string;
}

export interface CourseAttributes {
  authorNames?: string[];
  bannerUrl?: string;
  catalogs?: string[];
  completionDateSameAsApprovalDate?: boolean;
  downloadable?: boolean;
  dateCreated?: string;
  datePublished?: string;
  dateUpdated?: string;
  /** @format int64 */
  duration?: number;
  enableSocial?: boolean;
  effectiveModifiedDate?: string;
  effectivenessData?: string;
  /** @format int32 */
  effectivenessIndex?: number;
  enrollmentType?: string;
  externalSkillNames?: string[];
  /** @format int32 */
  gracePeriod?: number;
  hasOptionalLoResources?: boolean;
  hasPreview?: boolean;
  imageUrl?: string;
  instanceSwitchEnabled?: boolean;
  loFormat?: string;
  /** @format int32 */
  loResourceCompletionCount?: number;
  loType?: string;
  moduleResetEnabled?: boolean;
  modulesMandatory?: boolean;
  multienrollmentEnabled?: boolean;
  /** @format int32 */
  price?: number;
  /** @format int32 */
  recurVersion?: number;
  recurred?: boolean;
  /** @format int32 */
  recurringMonths?: number;
  rootCertificationId?: string;
  showAggregatedResources?: boolean;
  state?: string;
  tags?: string[];
  unenrollmentAllowed?: boolean;
  uniqueId?: string;
  whoShouldTake?: string[];
  authorDetails?: AuthorDetail[];
  catalogLabels?: CatalogLabel[];
  extensionOverrides?: ExtensionOverride[];
  localizedMetadata?: LocalizedMetadata[];
  prerequisiteConstraints?: PrerequisiteConstraint[];
  products?: ProductRef[];
  rating?: Rating;
  sections?: Section[];
  instructorNames?: string[];
  avatarUrls?: string[];
  completionDeadline?: string;
  contentType?: string;
  dateStart?: string;
  /** @format int64 */
  desiredDuration?: number;
  hasQuiz?: boolean;
  hasToc?: boolean;
  isDefault?: boolean;
  locale?: string;
  location?: string;
  name?: string;
  onlyQuiz?: boolean;
  reportingType?: string;
  roomLocation?: string;
  externalReporting?: boolean;
  isExpiredSubmission?: boolean;
  loResourceType?: string;
  multipleAttemptEnabled?: boolean;
  previewEnabled?: boolean;
  resourceType?: string;
  submissionEnabled?: boolean;
  vcHostingSystem?: string;
  sessionRecordingInfo?: any[];
  isAET?: boolean;
  isFlexible?: boolean;
  /** @format int32 */
  seatLimit?: number;
  completed?: boolean;
  hasPassed?: boolean;
  /** @format int32 */
  highestScore?: number;
  /** @format int32 */
  maxScore?: number;
  /** @format int32 */
  progressPercent?: number;
  /** @format int32 */
  score?: number;
  dateCompleted?: string;
  dateEnrolled?: string;
  enrollmentSource?: string;
  enrollmentState?: string;
  /** @format int32 */
  credits?: number;
  learningObjectId?: string;
  skillName?: string;
  level?: string;
  /** @format int32 */
  maxCredits?: number;
  roomInfo?: string;
  roomName?: string;
  avatarUrl?: string;
  binUserId?: string;
  bio?: string;
  contentLocale?: string;
  email?: string;
  enrollOnClick?: boolean;
  gamificationEnabled?: boolean;
  lastLoginDate?: string;
  /** @format int32 */
  pointsEarned?: number;
  /** @format int32 */
  pointsRedeemed?: number;
  preferredResolution?: string;
  profile?: string;
  timeZoneCode?: string;
  uiLocale?: string;
  userType?: string;
  userUniqueId?: string;
  isBookmarked?: boolean;
  isEnhancedLp?: boolean;
  isExternal?: boolean;
  isMqaEnabled?: boolean;
  isPrerequisiteEnforced?: boolean;
  isSubLoOrderEnforced?: boolean;
}

export interface CourseDataBlock {
  id?: string;
  type?: string;
  attributes?: CourseAttributes;
  relationships?: CourseRelationships;
  instanceId?: string;
  courseId?: string;
  loResourceId?: string;
  typeSuffix?: string;
  resourceIndex?: string;
}

export interface CourseRelationData {
  type?: string;
  id?: string;
  userId?: string;
  instanceId?: string;
  courseId?: string;
  loResourceId?: string;
  typeSuffix?: string;
  resourceIndex?: string;
}

export interface CourseRelationDataWrapper {
  data?: CourseRelationData[];
}

export interface CourseRelationSingleData {
  data?: CourseRelationData;
}

export interface CourseRelationships {
  authors?: CourseRelationDataWrapper;
  enrollment?: CourseRelationSingleData;
  instances?: CourseRelationDataWrapper;
  prerequisiteLos?: CourseRelationDataWrapper;
  recommendationProducts?: CourseRelationDataWrapper;
  recommendationRoles?: CourseRelationDataWrapper;
  skills?: CourseRelationDataWrapper;
  subLos?: CourseRelationDataWrapper;
  supplementaryLos?: CourseRelationDataWrapper;
  supplementaryResources?: CourseRelationDataWrapper;
  learningObject?: CourseRelationSingleData;
  loInstance?: CourseRelationSingleData;
  loResources?: CourseRelationDataWrapper;
  resources?: CourseRelationDataWrapper;
  learner?: CourseRelationSingleData;
  loResourceGrades?: CourseRelationDataWrapper;
  loResource?: CourseRelationSingleData;
  skillLevel?: CourseRelationSingleData;
  levels?: CourseRelationDataWrapper;
  skill?: CourseRelationSingleData;
  room?: CourseRelationSingleData;
  l1FeedbackInfo?: CourseRelationSingleData;
  account?: CourseRelationSingleData;
}

export interface Cursor {
  previous?: string;
  next?: string;
}

export interface ExtensionOverride {
  id?: string;
  defaultScope?: string;
  enabled?: string;
  /** @format int32 */
  height?: number;
  invocationType?: string;
  launchType?: string;
  url?: string;
  /** @format int32 */
  width?: number;
}

export interface LocalizedMetadata {
  description?: string;
  id?: string;
  label?: string;
  locale?: string;
  name?: string;
  overview?: string;
  richTextOverview?: string;
  type?: string;
}

export interface PrerequisiteConstraint {
  mandatory?: boolean;
  prerequisiteLoId?: string;
}

export interface ProductRef {
  id?: string;
  levels?: string[];
  name?: string;
}

export interface Rating {
  /** @format double */
  averageRating?: number;
  /** @format int32 */
  ratingsCount?: number;
}

export interface Section {
  loIds?: string[];
  mandatory?: boolean;
  /** @format int32 */
  mandatoryLoCount?: number;
  sectionId?: string;
}

export interface AdobeUserLearningHistoryResponse {
  cursor?: Cursor;
  data?: LearningHistoryDataBlock[];
}

export interface EnrollmentRelationships {
  learner?: LearningHistoryRelationSingleData;
  learningObject?: LearningHistoryRelationSingleData;
  loInstance?: LearningHistoryRelationSingleData;
  loResourceGrades?: LearningHistoryRelationDataWrapper;
}

export interface LearningHistoryAttributes {
  dateCompleted?: string;
  dateEnrolled?: string;
  dateStarted?: string;
  enrollmentSource?: string;
  hasPassed?: boolean;
  /** @format int32 */
  progressPercent?: number;
  /** @format int32 */
  score?: number;
  state?: string;
  courseState?: string;
}

export interface LearningHistoryDataBlock {
  id?: string;
  type?: string;
  attributes?: LearningHistoryAttributes;
  relationships?: EnrollmentRelationships;
  userId?: string;
  instanceId?: string;
  courseId?: string;
}

export interface LearningHistoryRelationData {
  id?: string;
  type?: string;
  userId?: string;
  instanceId?: string;
  courseId?: string;
}

export interface LearningHistoryRelationDataWrapper {
  data?: LearningHistoryRelationData[];
}

export interface LearningHistoryRelationSingleData {
  data?: LearningHistoryRelationData;
}

export interface AdobeCatalogResponse {
  links?: Links;
  data?: DataBlock;
}

export interface Attributes {
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  dateUpdated?: string;
  description?: string;
  imageUrl?: string;
  name?: string;
  state?: string;
  default?: boolean;
  listable?: boolean;
  internallySearchable?: boolean;
  isDefault?: boolean;
  isInternallySearchable?: boolean;
  isListable?: boolean;
}

export interface DataBlock {
  id?: string;
  type?: string;
  attributes?: Attributes;
}

export interface Links {
  self?: string;
}

export interface AdobeCalendarResponseDto {
  cursor?: Cursor;
  data?: CalendarUserCalendar[];
  included?: CalendarIncluded[];
}

export interface CalendarAttributes {
  course?: string;
  courseInstanceName?: string;
  courseName?: string;
  courseType?: string;
  dateEnd?: string;
  dateStart?: string;
  enrolled?: boolean;
  enrolledToCourseInstance?: boolean;
  instructorNames?: string[];
  location?: string;
  /** @format int32 */
  month?: number;
  /** @format int32 */
  quarter?: number;
  sessionName?: string;
}

export interface CalendarCourseData {
  id?: string;
  type?: string;
}

export interface CalendarCourseRelationship {
  data?: CalendarCourseData;
}

export interface CalendarIncluded {
  id?: string;
  type?: string;
  attributes?: Record<string, any>;
  relationships?: Record<string, any>;
}

export interface CalendarInstructorRelationship {
  id?: string;
  type?: string;
}

export interface CalendarInstructorRelationships {
  data?: CalendarInstructorRelationship[];
}

export interface CalendarRelationships {
  course?: CalendarCourseRelationship;
  instructors?: CalendarInstructorRelationships;
  room?: CalendarRoomRelationship;
}

export interface CalendarRoomData {
  id?: string;
  type?: string;
}

export interface CalendarRoomRelationship {
  data?: CalendarRoomData;
}

export interface CalendarUserCalendar {
  id?: string;
  type?: string;
  attributes?: CalendarAttributes;
  relationships?: CalendarRelationships;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string =
    "https://learning-app.us-east-1.staging.atl-paas.net";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title No title
 * @baseUrl https://learning-app.us-east-1.staging.atl-paas.net
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  contentful = {
    /**
     * @description learning-app service uses this endpoint to track changes of specific contentful reward entry.
     *
     * @tags contentful-webhook-controller
     * @name TrackContentfulCourseRewardEntryUpdate
     * @summary consumes rewardContentfulId
     * @request PUT:/contentful/webhook/entry/reward
     * @secure
     */
    trackContentfulCourseRewardEntryUpdate: (
      data: ContentfulWebhookEntryDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/contentful/webhook/entry/reward`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Consumes Contentful webhook events of course entry on `publish` action only learning-app service uses this endpoint to track changes of specific contentful course entry.
     *
     * @tags contentful-webhook-controller
     * @name TrackContentfulCourseEntryPublishEvent
     * @summary consumes courseContentfulId
     * @request PUT:/contentful/webhook/entry/course
     * @secure
     */
    trackContentfulCourseEntryPublishEvent: (
      data: ContentfulWebhookEntryDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/contentful/webhook/entry/course`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Consumes Contentful webhook events of course entry on `delete` action only learning-app service uses this endpoint to track changes of specific contentful course entry.
     *
     * @tags contentful-webhook-controller
     * @name TrackContentfulCourseEntryDeleteEvent
     * @summary consumes courseContentfulId
     * @request DELETE:/contentful/webhook/entry/course
     * @secure
     */
    trackContentfulCourseEntryDeleteEvent: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contentful/webhook/entry/course`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags contentful-webhook-controller
     * @name TrackContentfulLearningPathUpdate
     * @request PUT:/contentful/webhook/entry/content-type
     * @secure
     */
    trackContentfulLearningPathUpdate: (
      data: ContentfulWebhookEntryContentTypeDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/contentful/webhook/entry/content-type`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags contentful-webhook-controller
     * @name SendSearchableDataToAtlenz
     * @request PUT:/contentful/webhook/entry/atlenz
     * @secure
     */
    sendSearchableDataToAtlenz: (
      data: ContentfulWebhookEntryContentTypeDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/contentful/webhook/entry/atlenz`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description This learning-app endpoint accepts graphql query and calls GraphQL Content API which returns contentful entity in json format.
     *
     * @tags contentful-graphql-controller
     * @name PostGraphQl
     * @summary returns entity according to graphql query
     * @request POST:/contentful/graphql
     */
    postGraphQl: (
      data: ContentfulGraphQlRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/contentful/graphql`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Consumes Contentful webhook events of lesson entry on `delete` action only learning-app service uses this endpoint to track changes of specific contentful course entry.
     *
     * @tags contentful-webhook-controller
     * @name TrackContentfulLessonEntryDeleteEvent
     * @summary consumes courseContentfulId
     * @request DELETE:/contentful/webhook/entry/lesson
     * @secure
     */
    trackContentfulLessonEntryDeleteEvent: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contentful/webhook/entry/lesson`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Consumes Contentful webhook events of learning path entry on `delete` action only learning-app service uses this endpoint to track changes of specific contentful course entry.
     *
     * @tags contentful-webhook-controller
     * @name TrackContentfulLearningPathEntryDeleteEvent
     * @summary consumes courseContentfulId
     * @request DELETE:/contentful/webhook/entry/learning-path
     * @secure
     */
    trackContentfulLearningPathEntryDeleteEvent: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contentful/webhook/entry/learning-path`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  ccp = {
    /**
     * No description
     *
     * @tags ccp-controller
     * @name GetBillToParty
     * @request GET:/ccp/bill-to-party
     */
    getBillToParty: (params: RequestParams = {}) =>
      this.request<BillToPartyDto, any>({
        path: `/ccp/bill-to-party`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ccp-controller
     * @name UpdateBillToParty
     * @request PUT:/ccp/bill-to-party
     */
    updateBillToParty: (
      data: BillToPartyRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<BillToPartyDto, any>({
        path: `/ccp/bill-to-party`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ccp-controller
     * @name TransactionAccount
     * @request GET:/ccp/transaction-account
     */
    transactionAccount: (params: RequestParams = {}) =>
      this.request<TransactionAccountsResponseDto, any>({
        path: `/ccp/transaction-account`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ccp-controller
     * @name TransactionAccount1
     * @request POST:/ccp/transaction-account
     */
    transactionAccount1: (
      data: TransactionAccountRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<TransactionAccountResponseDto, any>({
        path: `/ccp/transaction-account`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ccp-controller
     * @name GetAllShipToParties
     * @request GET:/ccp/ship-to-parties
     */
    getAllShipToParties: (params: RequestParams = {}) =>
      this.request<ShipToPartyWrapperDto, any>({
        path: `/ccp/ship-to-parties`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ccp-controller
     * @name CreateShipToParties
     * @request POST:/ccp/ship-to-parties
     */
    createShipToParties: (
      data: ShipToPartiesRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<ShipToPartyDto, any>({
        path: `/ccp/ship-to-parties`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ccp-controller
     * @name CreateOrder
     * @request POST:/ccp/order
     */
    createOrder: (data: OrderRequestDto, params: RequestParams = {}) =>
      this.request<OrderResponseDto, any>({
        path: `/ccp/order`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ccp-controller
     * @name GetInvoiceGroups
     * @request GET:/ccp/invoice-groups
     */
    getInvoiceGroups: (params: RequestParams = {}) =>
      this.request<InvoiceGroupWrapperDto, any>({
        path: `/ccp/invoice-groups`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ccp-controller
     * @name GetInvoiceGroups1
     * @request POST:/ccp/invoice-groups
     */
    getInvoiceGroups1: (
      data: InvoiceGroupRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<InvoiceGroupDto, any>({
        path: `/ccp/invoice-groups`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ccp-controller
     * @name GetShipToPartiesById
     * @request GET:/ccp/ship-to-parties/{id}
     */
    getShipToPartiesById: (id: string, params: RequestParams = {}) =>
      this.request<ShipToPartyDto, any>({
        path: `/ccp/ship-to-parties/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ccp-controller
     * @name GetOrderById
     * @request GET:/ccp/order/{orderId}
     */
    getOrderById: (orderId: string, params: RequestParams = {}) =>
      this.request<OrderDetailsDto, any>({
        path: `/ccp/order/${orderId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ccp-controller
     * @name Entitlements
     * @request GET:/ccp/entitlements
     */
    entitlements: (params: RequestParams = {}) =>
      this.request<EntitlementResponseDto, any>({
        path: `/ccp/entitlements`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ccp-controller
     * @name Entitlements1
     * @request GET:/ccp/entitlements/{entitlementId}/details
     */
    entitlements1: (entitlementId: string, params: RequestParams = {}) =>
      this.request<EntitlementDetailsDtoResponseDto, any>({
        path: `/ccp/entitlements/${entitlementId}/details`,
        method: "GET",
        ...params,
      }),
  };
  search = {
    /**
     * No description
     *
     * @tags search-controller
     * @name Search
     * @summary Search for content by query
     * @request POST:/search
     */
    search: (data: SearchDto, params: RequestParams = {}) =>
      this.request<AtlenzSearchResponseDto, any>({
        path: `/search`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-controller
     * @name GetSearchCounters
     * @summary Retrieve filter counters
     * @request POST:/search/counters
     */
    getSearchCounters: (data: SearchDto, params: RequestParams = {}) =>
      this.request<FiltersCounters, any>({
        path: `/search/counters`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  kms = {
    /**
     * @description Creates a user in Nitro if it does not exists on Nitro Studio
     *
     * @tags kms-controller
     * @name CreateUser
     * @summary Creates a user in Nitro if it does not exists on Nitro Studio
     * @request POST:/kms/user
     */
    createUser: (data: KmsUserDto, params: RequestParams = {}) =>
      this.request<KmsUserCreationDto, any>({
        path: `/kms/user`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  adobe = {
    /**
     * No description
     *
     * @tags adobe-webhook-controller
     * @name ProcessUnenrollment
     * @request POST:/adobe/webhook/unenrollment
     * @secure
     */
    processUnenrollment: (data: AccountEvents, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/adobe/webhook/unenrollment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags adobe-webhook-controller
     * @name ProcessEnrollment
     * @request POST:/adobe/webhook/enrollments
     * @secure
     */
    processEnrollment: (data: AccountEvents, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/adobe/webhook/enrollments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags adobe-webhook-controller
     * @name ProcessCompletions
     * @request POST:/adobe/webhook/completions
     * @secure
     */
    processCompletions: (data: AccountEvents, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/adobe/webhook/completions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Adobe Base API, Adobe Learner-Scoped API
     * @name GetEnrollments
     * @summary Get enrollments for user
     * @request GET:/adobe/learner/enrollments
     */
    getEnrollments: (
      query?: {
        email?: string;
        aaid?: string;
        userId?: string;
        enrollmentId?: string;
        include?: string;
        pageCursor?: string;
        /**
         * @format int32
         * @min 1
         * @max 10
         */
        pageLimit?: number;
        /**
         * @maxItems 4
         * @minItems 0
         */
        filterLoTypes?: string[];
        filterStates?: string;
        filterHasDeadline?: boolean;
        filterCompleted?: boolean;
        includeHierarchicalEnrollments?: boolean;
        /**
         * @maxItems 10
         * @minItems 0
         */
        ids?: string[];
        /** @pattern dateEnrolled|-dateEnrolled|dueDate */
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeUserLearningHistoryResponse, any>({
        path: `/adobe/learner/enrollments`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Adobe Base API, Adobe Learner-Scoped API
     * @name CreateEnrollment
     * @request POST:/adobe/learner/enrollments
     */
    createEnrollment: (
      query?: {
        loId?: string;
        loInstanceId?: string;
        email?: string;
        aaid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/adobe/learner/enrollments`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves user info from an ALM instance using the user's email address.
     *
     * @tags Adobe Base API, Adobe Admin-Scoped API
     * @name GetUserByEmail
     * @summary Get user by email address
     * @request GET:/adobe/admin/users
     */
    getUserByEmail: (
      query: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeUserResponseDto, any>({
        path: `/adobe/admin/users`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Creates a new user in an ALM instance with the specified information.
     *
     * @tags Adobe Base API, Adobe Admin-Scoped API
     * @name CreateUser1
     * @summary Create user
     * @request POST:/adobe/admin/users
     */
    createUser1: (
      query: {
        email: string;
        aaid: string;
        name: string;
        roles?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeUserResponseDto, AdobeUserResponseDto>({
        path: `/adobe/admin/users`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * @description Deletes a user from an ALM instance by fetching the user via email and deleting their account.
     *
     * @tags Adobe Base API, Adobe Admin-Scoped API
     * @name DeleteUser
     * @summary Delete user
     * @request DELETE:/adobe/admin/users
     */
    deleteUser: (
      query: {
        email: string;
        aaid: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/adobe/admin/users`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * @description Updates user info in an ALM instance by fetching the user via email and patching their information. All fields except email and aaid are optional.
     *
     * @tags Adobe Base API, Adobe Admin-Scoped API
     * @name PatchUser
     * @summary Update user information
     * @request PATCH:/adobe/admin/users
     */
    patchUser: (
      query: {
        email: string;
        aaid: string;
        newEmail?: string;
        name?: string;
        roles?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeUserResponseDto, AdobeUserResponseDto>({
        path: `/adobe/admin/users`,
        method: "PATCH",
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves ALL ILT courses for the My Learning page with session details, enrollment status, and pre-calculated filter tags for frontend filtering
     *
     * @tags ILT Learning
     * @name GetIltLearningCards
     * @summary Get ALL ILT learning content for learner
     * @request GET:/adobe/learner/my-learning/live-training
     */
    getIltLearningCards: (
      query?: {
        /**
         * Maximum number of results to return (pagination only)
         * @format int32
         * @min 1
         * @max 50
         * @default 50
         */
        limit?: number;
        /** Pagination cursor for next set of results */
        cursor?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<IltLearningCardsResponse, IltLearningCardsResponse>({
        path: `/adobe/learner/my-learning/live-training`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves learning objects from ALM with optional filtering and pagination.
     *
     * @tags Adobe Base API, Adobe Learner-Scoped API
     * @name GetLearningObjects
     * @summary Get learning objects
     * @request GET:/adobe/learner/learning-objects
     */
    getLearningObjects: (
      query?: {
        email?: string;
        aaid?: string;
        include?: string;
        pageCursor?: string;
        /**
         * @format int32
         * @min 1
         * @max 10
         */
        pageLimit?: number;
        /**
         * @maxItems 4
         * @minItems 0
         */
        filterLoTypes?: string[];
        filterCatalogIds?: string[];
        /**
         * @maxItems 3
         * @minItems 0
         */
        filterLearnerState?: string[];
        filterBookmarks?: boolean;
        /** @pattern dateCreated|recommendationScore|name */
        sort?: string;
        filterCityName?: string[];
        filterAnnouncedGroups?: string[];
        filterSkillName?: string[];
        filterSkillLevel?: string[];
        filterTagName?: string[];
        language?: string[];
        /**
         * @maxItems 10
         * @minItems 0
         */
        ids?: string[];
        filterDurationRange?: string[];
        filterPriceRange?: string[];
        /** @pattern paid|free */
        filterPrice?: string;
        filterLoFormat?: string[];
        filterIgnoreHigherOrderLoEnrollment?: boolean;
        filterIgnoreEnhancedLp?: boolean;
        /**
         * @maxItems 4
         * @minItems 0
         */
        sortLanguage?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeCourseResponseDto, any>({
        path: `/adobe/learner/learning-objects`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves learning object from ALM.
     *
     * @tags Adobe Base API, Adobe Learner-Scoped API
     * @name GetLearningObjectsById
     * @summary Get learning objects by learning object ID
     * @request GET:/adobe/learner/learning-objects/{learningObjectId}
     */
    getLearningObjectsById: (
      learningObjectId: string,
      query: {
        include?: string;
        /** User email of learner */
        email: any;
        /** aaid of learner */
        aaid: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeCourseResponseDto, any>({
        path: `/adobe/learner/learning-objects/${learningObjectId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Adobe Base API, Adobe Learner-Scoped API
     * @name GetLearnerTranscript
     * @request GET:/adobe/learner/learner-transcript
     */
    getLearnerTranscript: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/adobe/learner/learner-transcript`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Adobe Base API, Adobe Learner-Scoped API
     * @name GetCourses
     * @request GET:/adobe/learner/courses
     */
    getCourses: (
      query?: {
        courseFormat?:
          | "BLENDED"
          | "CLASSROOM"
          | "SELF_PACED"
          | "VIRTUAL_CLASSROOM";
        include?: "LO_RESOURCES";
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeCourseResponseDto, any>({
        path: `/adobe/learner/courses`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Adobe Base API, Adobe Learner-Scoped API
     * @name GetCourse
     * @request GET:/adobe/learner/courses/{courseId}
     */
    getCourse: (
      courseId: string,
      query?: {
        courseFormat?:
          | "BLENDED"
          | "CLASSROOM"
          | "SELF_PACED"
          | "VIRTUAL_CLASSROOM";
        include?: "LO_RESOURCES";
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeCourseResponseDto, any>({
        path: `/adobe/learner/courses/${courseId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Adobe Base API, Adobe Learner-Scoped API
     * @name GetCoursesByName
     * @request GET:/adobe/learner/course/author
     */
    getCoursesByName: (
      query: {
        authorName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeCourseResponseDto, any>({
        path: `/adobe/learner/course/author`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Adobe Base API, Adobe Learner-Scoped API
     * @name GetCoursesById
     * @request GET:/adobe/learner/course/author/{authorId}
     */
    getCoursesById: (authorId: string, params: RequestParams = {}) =>
      this.request<AdobeCourseResponseDto, any>({
        path: `/adobe/learner/course/author/${authorId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Adobe Base API, Adobe Learner-Scoped API
     * @name GetCatalog
     * @request GET:/adobe/learner/catalog/{catalogId}
     */
    getCatalog: (catalogId: string, params: RequestParams = {}) =>
      this.request<AdobeCatalogResponse, any>({
        path: `/adobe/learner/catalog/${catalogId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Adobe Base API, Adobe Learner-Scoped API
     * @name GetLearnerCalendar
     * @request GET:/adobe/learner/calendar
     */
    getLearnerCalendar: (
      query?: {
        /** Mention any additional model to be tagged along with this model. Valid values: containerLO, course, instructors, room */
        include?: string;
        /**
         * Set of months from 1 to 12 inclusive
         * @format int32
         * @min 1
         * @max 12
         */
        month?: number;
        /**
         * Mention the year for which the data is being requested. Maximum allowed queryable duration is 2 years from current month.
         * @format int32
         * @min 2000
         */
        year?: number;
        /**
         * Set of quarters from 1 to 4 inclusive
         * @format int32
         * @min 1
         * @max 4
         */
        quarter?: number;
        /** Set currentMonthOnly=true to fetch calendar for current month only. The value can not used with month and quarter parameters. Default value is false */
        currentMonthOnly?: boolean;
        /** Set allSessions=true to get all calendar sessions. If not, only the earliest session per course is returned. Default value is false. Above filters only work when allSessions=true. */
        allSessions?: boolean;
        /** Filter the list based on this catalog id. Provide multiple values in new lines. */
        catalogIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeCalendarResponseDto, any>({
        path: `/adobe/learner/calendar`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves user info from an ALM instance using the user's ALM user id.
     *
     * @tags Adobe Base API, Adobe Admin-Scoped API
     * @name GetUserById
     * @summary Get user by user id
     * @request GET:/adobe/admin/users/{userId}
     */
    getUserById: (userId: string, params: RequestParams = {}) =>
      this.request<AdobeUserResponseDto, any>({
        path: `/adobe/admin/users/${userId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Retrieves all user groups associated with a specific user from ALM.
     *
     * @tags Adobe Base API, Adobe Admin-Scoped API
     * @name GetUserGroupsForUser
     * @summary Get user groups for a user by user id
     * @request GET:/adobe/admin/users/{userId}/userGroups
     */
    getUserGroupsForUser: (userId: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/adobe/admin/users/${userId}/userGroups`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Retrieves all user groups associated with a specific user from ALM using email address.
     *
     * @tags Adobe Base API, Adobe Admin-Scoped API
     * @name GetUserGroupsByEmail
     * @summary Get user groups for a user by email
     * @request GET:/adobe/admin/users/userGroups
     */
    getUserGroupsByEmail: (
      query: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/adobe/admin/users/userGroups`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves learning objects from ALM with optional filtering and pagination.
     *
     * @tags Adobe Base API, Adobe Admin-Scoped API
     * @name GetLearningObjects1
     * @summary Get learning objects
     * @request GET:/adobe/admin/learning-objects
     */
    getLearningObjects1: (
      query?: {
        email?: string;
        aaid?: string;
        include?: string;
        pageCursor?: string;
        /**
         * @format int32
         * @min 1
         * @max 10
         */
        pageLimit?: number;
        /**
         * @maxItems 4
         * @minItems 0
         */
        filterLoTypes?: string[];
        filterCatalogIds?: string[];
        /**
         * @maxItems 3
         * @minItems 0
         */
        filterLearnerState?: string[];
        filterBookmarks?: boolean;
        /** @pattern dateCreated|recommendationScore|name */
        sort?: string;
        filterCityName?: string[];
        filterAnnouncedGroups?: string[];
        filterSkillName?: string[];
        filterSkillLevel?: string[];
        filterTagName?: string[];
        language?: string[];
        /**
         * @maxItems 10
         * @minItems 0
         */
        ids?: string[];
        filterDurationRange?: string[];
        filterPriceRange?: string[];
        /** @pattern paid|free */
        filterPrice?: string;
        filterLoFormat?: string[];
        filterIgnoreHigherOrderLoEnrollment?: boolean;
        filterIgnoreEnhancedLp?: boolean;
        /**
         * @maxItems 4
         * @minItems 0
         */
        sortLanguage?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeCourseResponseDto, any>({
        path: `/adobe/admin/learning-objects`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Adobe Base API, Adobe Admin-Scoped API
     * @name GetEnrollments1
     * @summary Get enrollments for user
     * @request GET:/adobe/admin/enrollments
     */
    getEnrollments1: (
      query?: {
        email?: string;
        aaid?: string;
        userId?: string;
        enrollmentId?: string;
        include?: string;
        pageCursor?: string;
        /**
         * @format int32
         * @min 1
         * @max 10
         */
        pageLimit?: number;
        /**
         * @maxItems 4
         * @minItems 0
         */
        filterLoTypes?: string[];
        filterStates?: string;
        filterHasDeadline?: boolean;
        filterCompleted?: boolean;
        includeHierarchicalEnrollments?: boolean;
        /**
         * @maxItems 10
         * @minItems 0
         */
        ids?: string[];
        /** @pattern dateEnrolled|-dateEnrolled|dueDate */
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeUserLearningHistoryResponse, any>({
        path: `/adobe/admin/enrollments`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves learning objects from ALM with optional filtering and pagination. Uses an admin user to impersonate a learner for anonymous user scenarios.
     *
     * @tags Adobe Base API, Adobe Admin-Learner API
     * @name GetLearningObjects2
     * @summary Get learning objects
     * @request GET:/adobe/admin-learner/learning-objects
     */
    getLearningObjects2: (
      query?: {
        email?: string;
        aaid?: string;
        include?: string;
        pageCursor?: string;
        /**
         * @format int32
         * @min 1
         * @max 10
         */
        pageLimit?: number;
        /**
         * @maxItems 4
         * @minItems 0
         */
        filterLoTypes?: string[];
        filterCatalogIds?: string[];
        /**
         * @maxItems 3
         * @minItems 0
         */
        filterLearnerState?: string[];
        filterBookmarks?: boolean;
        /** @pattern dateCreated|recommendationScore|name */
        sort?: string;
        filterCityName?: string[];
        filterAnnouncedGroups?: string[];
        filterSkillName?: string[];
        filterSkillLevel?: string[];
        filterTagName?: string[];
        language?: string[];
        /**
         * @maxItems 10
         * @minItems 0
         */
        ids?: string[];
        filterDurationRange?: string[];
        filterPriceRange?: string[];
        /** @pattern paid|free */
        filterPrice?: string;
        filterLoFormat?: string[];
        filterIgnoreHigherOrderLoEnrollment?: boolean;
        filterIgnoreEnhancedLp?: boolean;
        /**
         * @maxItems 4
         * @minItems 0
         */
        sortLanguage?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeCourseResponseDto, any>({
        path: `/adobe/admin-learner/learning-objects`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves learning object from ALM by ID. Uses an admin user to impersonate a learner for anonymous user scenarios.
     *
     * @tags Adobe Base API, Adobe Admin-Learner API
     * @name GetLearningObjectsById1
     * @summary Get learning objects by learning object ID
     * @request GET:/adobe/admin-learner/learning-objects/{learningObjectId}
     */
    getLearningObjectsById1: (
      learningObjectId: string,
      query?: {
        include?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeCourseResponseDto, any>({
        path: `/adobe/admin-learner/learning-objects/${learningObjectId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Adobe Base API, Adobe Admin-Learner API
     * @name GetEnrollments2
     * @summary Get enrollments for user
     * @request GET:/adobe/admin-learner/enrollments
     */
    getEnrollments2: (
      query?: {
        email?: string;
        aaid?: string;
        userId?: string;
        enrollmentId?: string;
        include?: string;
        pageCursor?: string;
        /**
         * @format int32
         * @min 1
         * @max 10
         */
        pageLimit?: number;
        /**
         * @maxItems 4
         * @minItems 0
         */
        filterLoTypes?: string[];
        filterStates?: string;
        filterHasDeadline?: boolean;
        filterCompleted?: boolean;
        includeHierarchicalEnrollments?: boolean;
        /**
         * @maxItems 10
         * @minItems 0
         */
        ids?: string[];
        /** @pattern dateEnrolled|-dateEnrolled|dueDate */
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdobeUserLearningHistoryResponse, any>({
        path: `/adobe/admin-learner/enrollments`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Adobe Base API, Adobe Learner-Scoped API
     * @name DeleteEnrollment
     * @request DELETE:/adobe/learner/enrollments/{id}
     */
    deleteEnrollment: (
      id: string,
      query: {
        /** User email of learner */
        email: any;
        /** aaid of learner */
        aaid: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/adobe/learner/enrollments/${id}`,
        method: "DELETE",
        query: query,
        ...params,
      }),
  };
  heartbeat = {
    /**
     * No description
     *
     * @tags health-check-controller
     * @name Heartbeat
     * @request GET:/heartbeat
     */
    heartbeat: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/heartbeat`,
        method: "GET",
        ...params,
      }),
  };
  deepcheck = {
    /**
     * No description
     *
     * @tags health-check-controller
     * @name Deepcheck
     * @request GET:/deepcheck
     */
    deepcheck: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/deepcheck`,
        method: "GET",
        ...params,
      }),
  };
  progress = {
    /**
     * No description
     *
     * @tags hard-delete-controller
     * @name Delete
     * @request DELETE:/progress/hard-delete/{atlassianId}
     */
    delete: (atlassianId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/progress/hard-delete/${atlassianId}`,
        method: "DELETE",
        ...params,
      }),
  };
}
